export default "<p>home work!</p>\r\n<div class=\"content-wrapper\">\r\n<div id=\"map\"></div></div>\r\n<button (click)=\"clearLayer()\">Clear</button>";